module.exports = __webpack_public_path__ + "img/owner-mark.ff147cd4.png";